import React from 'react'
import './Organisation.css';
// import './JobProcess.css';
import { Link } from 'react-router-dom'
import JobHeader from './JobHeader'
import SideBar from './SideBar'
export default function Organisation() {
  return (
    <> 
    <JobHeader/>
    <div class ="jobProcess">
        <SideBar/>
    <div class ="Organisation">
<h1>Organisations</h1>
     <div className='org-content'><h2>Company</h2>
     Company<span className="mandatory">*</span><br/>
     0006jkjjjjjsj
     </div> 
     <div className='org-content'><h2>Cost Center</h2>
     Cost Center<span className="mandatory">*</span><br/>
     0006jkjjjjjsj<br/>
     </div> 
     <div className='org-content'><h2>Region</h2>
     Region<span className="mandatory">*</span><br/>
     0006jkjjjjjsj
     </div> 
     <div className='org-content'><h2>Other</h2>
     Other<span className="mandatory">*</span><br/>
        Direct or Indirect
     </div> 
    </div>
    </div>
    <div className='next-bar'>
    <button className='back-btn'>Back</button>
    <button className='next-btn'>Next</button>
          
        </div>
    </>
  )
}
